// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610081447/js/" + chunkId + "." + {"44":"427bc431","225":"a1477f03","481":"2ccd1293","486":"fb6768da","770":"ff34e2c4"}[chunkId] + ".0.7023203671202884.chunk.js";
};